module.exports = "<div class=\"container-fluid h-100\" style=\"overflow-y: auto\">\n   <div class=\"col-12 p-0 h-100\">\n      <router-outlet></router-outlet>\n   </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main